module.exports = __webpack_public_path__ + "img/swiper9.b5324ab8.png";